import "./index.scss";

const TopBar = ({ heading, description }) => {
  return (
    <div className="top-bar">
      <div className="main-heading">{heading}</div>
      <div className="main-text">{description}</div>
    </div>
  );
};

export default TopBar;
